import React, { ComponentProps } from 'react';
import { Controller, Control, FieldValues, Path } from 'react-hook-form';
import { TextField } from '@qbe/ads-core';

type TextFieldProps = ComponentProps<typeof TextField>;

type TextFieldControllerProps<T extends FieldValues> = {
  control: Control<T, any>;
  name: keyof FieldValues;
  label: string;
  capture?: boolean;
} & Partial<TextFieldProps>;

export function TextFieldController<T extends FieldValues>({
  control,
  name,
  label,
  capture = false,
  ...rest
}: TextFieldControllerProps<T>) {
  return (
    <Controller
      name={name as Path<T>}
      control={control}
      render={({ field: { ref, ...field }, fieldState: { error } }) => (
        <TextField
          {...field}
          {...rest}
          id={field.name}
          value={field.value!}
          error={!!error}
          label={label}
          inputProps={{
            ['data-track']: field.name,
            ['data-track-value']: capture ? 'capture' : 'mask',
            ['data-test']: field.name,
            ...(rest.inputProps || {}),
          }}
          helperText={error?.message}
        />
      )}
    />
  );
}
